<template>
    <div>
        <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo"/>

        <div class="container-butacas-wrapper scroll-smooth mb-2" v-if="!loading" ref="butacasWrapper">
            <div :class="'container-butacas animated fadeInLeft text-align-' + zona.print_align">
                <template v-for="(fila, index_fila) in filas">
                    <span :key="index_fila">
                        <span class="fila" style="margin-rigth: 10px">{{ fila.alias }}</span>
                        <div class="ml-3">
                            <template v-for="(asiento, index) in ordenarButacas(fila.asientos)">
                                <AsientoComponent :asiento="asiento" :fila="fila.alias" :front="true" :key="index+'_2'" @toggle="() => toggleSeleccion(asiento)"/>
                            </template>
                        </div>
                    </span>
                </template>
            </div>
        </div>
        <template v-else>
            <LoaderComponent/>
        </template>

        <LeyendaButacasComponent/>
    </div>
</template>

<script>
    import AsientoComponent from "@/components/backend/stepper/components/AsientoComponent";
    import TerrenoJuegoComponent from "../../../common/Asientos/TerrenoJuegoComponent.vue";
    import LeyendaButacasComponent from '@/components/common/Asientos/LeyendaButacasComponent.vue'

    export default {
        props: ['zona', 'asientos', 'forzar_adyacentes', 'can_click', 'stock'],
        data() {
            return {
                loading: true,
                filas: null,
                datos_compradores: [],
                precios: null,
                last_row: null,
                n_entradas: 6
            }
        },
        created() {
            if(this.stock && this.stock < this.n_entradas) {
                this.n_entradas = this.stock;
            }
            this.datos_compradores = this.asientos;
            this.getZona(this.zona.id);
        },
        watch : {
            zona() {
                this.getZona(this.zona.id);
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods: {
            getZona(id) {
                this.loading = true;
                var params = {
                    filters: {
                        zona_id: id,
                        conf: true,
                        tid: this.configuracion.hash_teatro
                    },
                    zona_id: id,
                    tid: this.configuracion.hash_teatro
                };

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.show'), params).then(res => {
                    this.filas = res.data.data.configuracion;
                    this.precios = res.data.data.precios;
                    this.loading = false;
                    this.$emit('cargado');
                });
            },
            toggleSeleccion : function(asiento) {
                if(this.can_click  && asiento.ocupado == false) {
                    if(asiento.seleccionado) {
                        for(var j in this.datos_compradores) {
                            if(this.datos_compradores[j].asiento.fila == asiento.fila && this.datos_compradores[j].asiento.asiento == asiento.asiento) {
                                this.datos_compradores.splice(j, 1);
                            }
                        }
                        asiento.seleccionado = false;
                    } else {
                        if(this.datos_compradores.length < this.n_entradas) {
                            var data = {
                                'asiento' : {
                                    fila : asiento.fila,
                                    asiento : asiento.asiento,
                                    zona_id : this.zona.id,
                                    zona_nombre : this.zona.name,
                                    seat_id: asiento.seat_id,
                                    lfp_id: asiento.seat_id
                                },

                                nombre : '',
                                apellidos : '',
                                dni : '',
                                telefono : '',
                                precios : this.precios,
                                url_imprimir : null,
                                es_nuevo : true,
                                precio: this.precios[0]
                            }

                            this.datos_compradores.push(data);
                            asiento.seleccionado = true;
                        } else {
                            this.$toast.error('Ya no es posible adquirir más abonos, se ha superado el límite.');
                        }
                    }
                }
                this.actualizarDatos();
            },
            actualizarDatos() {
                this.$emit('actualizarDatos', this.datos_compradores);
            },
            esConfiguracionAsientosValida() {
                if(!this.forzar_adyacentes) {
                    return true;
                }

                for(var fila in this.filas) {
                    for(var i in this.filas[fila]) {
                        if(i == 0) continue;

                        let actual = this.filas[fila][i];
                        let anterior = this.filas[fila][i-1];
                        if((actual.seleccionado && !anterior.seleccionado && !anterior.ocupado) ||
                            (anterior.seleccionado && !actual.seleccionado && !actual.ocupado)) {
                            return false;
                        }
                    }
                }
                return true;
            },
            scrollLeft() {
                this.$refs["butacasWrapper"].scrollBy(-this.$refs["butacasWrapper"].parentElement.scrollWidth, 0)
            },
            scrollRight() {
                this.$refs["butacasWrapper"].scrollBy(this.$refs["butacasWrapper"].parentElement.scrollWidth, 0)
            },
            ordenarButacas(butacas) {
                const keys = Object.keys(butacas).reverse();

                const array = [];

                keys.forEach(key => {
                    array.push(butacas[key]);
                })

                return array;
            }
        },
        components: {
            AsientoComponent, TerrenoJuegoComponent, LeyendaButacasComponent
        }
    }
</script>
